import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";




function Navbar() {

const [scroll,setscroll] = React.useState(0)

   useEffect(() => {
     window.scrollTo(0, 0);
   }, [scroll]);

  return (
    <NavbarWraper className="color">
      <NavbarLeft  > 
      <img src="/Images/logo6.png" alt="" />
     
       </NavbarLeft > 

      <NavBarRight>
        <StyledLink to="/" onClick={() => setscroll(scroll+1)} >Home</StyledLink>
        <StyledLink to="/about">About </StyledLink>
        <StyledLink to="/skills">Skills</StyledLink>
        <StyledLink to="/projects">Projects</StyledLink>
        <StyledLink to="/contact">Contact </StyledLink>
      </NavBarRight>
    </NavbarWraper>
  );
}
// ${(props) => props.theme.text.secondary};

const NavbarWraper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #404040;
  position: sticky;
  width: 100%;
  top: 0px;
  height: 60px;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.2);

  @media (max-width: 460px) {
    width: 100%;
    padding-left: 10px;
    padding-right: 10px;
  }
`;

const NavbarLeft = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  justify-content: flex-start;
  object-fit: contain;
  border-radius: 50%;
  margin-left: 30px;

  & img {
    width: 60px;
    height: 60px;
  }

  & span {
    color: white;
    font-family: "Agustina Regular";
    font-weight: bold;
    padding: 0 10px;
  }
`;
const NavBarRight = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-right: 30px;
  padding: 10px;
`;

const StyledLink = styled(Link)`
  cursor: pointer;
  word-wrap: break-word;
  color: ${(props) => props.theme.text.main};
  font-weight: 500;
  font-size: 18px;
  padding: 0 15px;
  display: block;
  text-decoration: none;

  &:hover {
    color: ${(props) => props.theme.LightTheme.white};
  }

  @media (max-width: 640px) {
    font-size: 16px;
    padding: 0 5px;
  }

  @media (max-width: 445px) {
    font-size: 14px;
    padding: 0 10px 0 5px;
  }
`;



export default Navbar;
